export default __webpack_public_path__ + "static/assets/c3873a5cbd8b72047db7f4db3844c161.png";